import React from 'react'
import './CustomerQueriesComponent.css'

const CustomerQueriesComponent = () => {
    return (
        <div className="banner_section" style={{ flex: "1" }}>
            <div className="container"><div className="customer_queries_section"><div className="row"><div className="table-responsive custom-table-01"><table className="table table-striped"><thead><tr><th>Sr.No</th>
                <th>Username</th>
                <th>Email</th>
                <th>Address</th>
                <th>Comment</th></tr></thead>
                <tbody><div className="col-lg-12"><div className="row justify-content-center"><h6>No Queries Yet</h6></div></div></tbody></table></div></div></div></div>
        </div>
    )
}

export default CustomerQueriesComponent
